import { render, staticRenderFns } from "./addPaPayroll.vue?vue&type=template&id=b1c787aa&"
import script from "./addPaPayroll.vue?vue&type=script&lang=js&"
export * from "./addPaPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports